import styled from 'styled-components';

const StrainsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  * {
    color: var(--fill-brand);
  }
`;

const MainTitle = styled.p`
  margin-bottom: 0.5rem;
  font-size: 20px;
  font-weight: 400;
  line-height: 32px;
`;

const TitleDashed = styled.p`
  margin-top: 1.5rem;
  border-top: 1px dashed var(--fill-brand);
  padding-top: 1.5rem;
  font-size: 18px;
  line-height: 25.2px;
  font-weight: 500;
`;

const DSLearnMore = ({ imageUrl }: { imageUrl?: string }) => {
  return (
    <StrainsWrapper>
      <MainTitle>Survivability</MainTitle>
      <p>
        Many probiotics—like gummies, powders, and drinks—dissolve during
        digestion. DS-01®’s proprietary ViaCap® system is engineered to
        protect probiotic strains from stomach acid, digestive enzymes, and
        bile.
      </p>

      <TitleDashed>ViaCap® Technology</TitleDashed>
      <p>
        Our proprietary dual-capsule system is built for a timed release to the
        colon: the prebiotic outer capsule releases in the upper GI tract and
        the probiotic inner capsule continues to the large intestine.
      </p>
      {imageUrl && (
        <img src={imageUrl} alt='Image of pills with contents around them' />
      )}
      <ul>
        <li>
          Outer capsule made from cellulose protects probiotics and prebiotics
          as they travel through the GI tract.
        </li>
        <li>
          Plant-based formula—no synthetic coatings like similar cap-in-cap
          systems.
        </li>
        <li>
          Engineered for precision delivery to the colon, where bacteria is
          needed to work effectively.
        </li>
      </ul>

      <TitleDashed>Digestive Survivability Testing (SHIME®)</TitleDashed>
      <p>
        To evaluate the survival of our probiotics, we use a Simulator of the
        Human Intestinal Microbial Ecosystem (SHIME®)—the closest simulation of
        the human gastrointestinal system. It recreates the physiological
        conditions of digestion (food uptake, peristalsis, digestive enzymes,
        pancreatic and bile acids) and time spent in each step to represent the
        dynamic microbial conditions of the human gastrointestinal tract.
      </p>
    </StrainsWrapper>
  );
};

export default DSLearnMore;
